import { registerPlugin } from '@capacitor/core';
const BarcodeScannerFragmentPlugin = registerPlugin('BarcodeScannerFragmentPlugin', {
    web: () => import('./web').then(m => new m.BarcodeScannerFragmentPluginWeb()),
});
export * from './definitions';
export { BarcodeScannerFragmentPlugin };
//# sourceMappingURL=index.js.map